import TrpCancelContent from '@/components/trp/TrpCancelContent';
import TrpLayout from '@/components/trp/TrpLayout';

const TrpCancelPage = () => {
  return (
    <TrpLayout>
      <TrpCancelContent />
    </TrpLayout>
  );
};

export const getServerSideProps = () => {
  return {
    props: {}
  };
};

export default TrpCancelPage;
